<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">
                {{ $t('studentDOB.pageTitle') }}
            </h1>
            <ts-breadcrumb :items="[
                { text: $t('toHomePage'), href: '/' },
                {
                    text: $t('studentDOB.pageTitle'),
                    active: true
                }
            ]" />
        </div>
        <ts-card>
            <ts-card-wrapper>
                <div class="row">
                    <div class="col-md-3">
                        <ts-loading-banner :loading="loading">
                            <form>
                                <fieldset>
                                    <legend>{{ $t('studentDOB.criteria') }}</legend>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label class="required">{{ $t('studentDOB.dob') }}</label>
                                            <a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate"
                                                :defaultPickerValue="rangeDate" @change="dateRangeChange">
                                                <template slot="renderExtraFooter"></template>
                                            </a-range-picker>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-12">
                                            <label>{{ $t('studentDOB.className') }}</label>
                                            <a-select style="width: 100%" v-model="model.class_id"
                                                :options="class_options" :show-search="true" :placeholder="$t('all')"
                                                :loading="fetching_class_operation" :filter-option="(input, option) =>
                                                    option.componentOptions.children[0].text
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                    " mode="multiple"></a-select>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-8 text-right">

                                        </div>
                                        <div class="col-md-4 text-right">
                                            <ts-button class="btn-block" color="primary" @click.prevent="preview"
                                                :waiting="waiting">{{
                                                    $t('preview') }}</ts-button>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </ts-loading-banner>
                    </div>
                    <div class="col-md-9">
                        <ts-card>
                            <ts-card-wrapper>
                                <form>
                                    <fieldset>
                                        <legend>{{ $t('studentDOB.preview') }}</legend>
                                        <ts-preview-pdf v-model="waiting" :src="src" />

                                    </fieldset>
                                </form>
                            </ts-card-wrapper>
                        </ts-card>
                    </div>
                </div>
            </ts-card-wrapper>
        </ts-card>
    </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
    name: 'ReportStudentDateOfBirth',
    data() {
        return {
            loading: false,
            fetching_class_operation: false,
            waiting: false,
            // rangeDate: [moment(), moment()],
            class_options: [],
            errors: new Errors(),
            src: '',
            rangeDate: [moment(), moment()],
            model: {
                class_id: [],
            },
        };
    },
    created() {
        this.fetchClasses()
    },
    methods: {
        ...mapActions('reportAcademic', ['getClass', 'studentDOB']),
        moment,

        dateRangeChange(dateRange) {
            this.$store.commit(
                'reportAcademic/SET_DATE_FROM',
                dateRange[0].format('DD-MM-YYYY')
            )
            this.$store.commit(
                'reportAcademic/SET_DATE_TO',
                dateRange[1].format('DD-MM-YYYY')
            )
            this.fetchData()
        },
        fetchClasses() {
            this.fetching_class_operation = true
            this.getClass({
                filter: {
                    branch_id: this.model.branch_id
                }
            })
                .then(response => {
                    this.class_options = response.data.map(el => ({
                        value: el.class_id,
                        label:
                            el.class_name +
                            ' | ' +
                            el.teacher.full_name_en +
                            ' | ' +
                            el.academic_study_time.study_time
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.fetching_class_operation = false
                })
        },
        preview() {
            this.waiting = true
            this.src = ''
            this.errors = new Errors()
            this.studentDOB(this.model)
                .then(response => {
                    this.src = response.url
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },
    },

};
</script>